import React from "react";
import i1 from "../Assets/Services/integrated.jpeg";
import i2 from "../Assets/Services/strategycreativityresult1.jpeg";

const LayoutDesign = () => {
  return (
    <section className="bg-[#f2f2f2] w-full">
      <div className="grid grid-cols-1 md:grid-cols-2">

        {/* TEXT 1 */}
        <div className="flex items-center justify-center px-6 py-12 sm:py-14 md:py-20 lg:py-24">
          <div className="max-w-md">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-3">
              Integrated Digital <br className="hidden sm:block" /> Solutions
            </h2>

            <div className="w-10 h-1 bg-pink-500 mb-4"></div>

            <p className="italic text-xs sm:text-sm md:text-base mb-3 text-gray-600">
              Insights, Metrics and Analytics - Everything is connected!
            </p>

            <p className="text-gray-500 text-xs sm:text-sm md:text-base leading-relaxed">
              In a digital world where everything's connected, we believe that the
              approach to digital communications has to be joined-up too.
            </p>
          </div>
        </div>

        {/* IMAGE 1 */}
        <div className="relative w-full overflow-hidden aspect-[4/3] sm:aspect-[16/10] md:aspect-auto md:min-h-[400px]">
          <img
            src={i1}
            alt="Integrated"
            className="w-full h-full object-cover md:object-cover"
          />

          <div className="absolute bottom-4 right-4 sm:bottom-6 sm:right-6">
            <h2 className="text-white text-sm sm:text-base md:text-lg font-bold">
              Everything is connected
            </h2>
          </div>
        </div>

        {/* IMAGE 2 */}
        <div className="relative w-full overflow-hidden aspect-[4/3] sm:aspect-[16/10] md:aspect-auto md:min-h-[400px] md:order-3">
          <img
            src={i2}
            alt="Strategy"
            className="w-full h-full object-cover"
          />
        </div>

        {/* TEXT 2 */}
        <div className="flex items-center justify-center px-6 py-12 sm:py-14 md:py-20 lg:py-24 md:order-4">
          <div className="max-w-md">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-3">
              Strategy, Creativity & Results!
            </h2>

            <div className="w-10 h-1 bg-pink-500 mb-4"></div>

            <p className="text-gray-600 text-xs sm:text-sm md:text-base leading-relaxed">
              We understand that each client is different and we follow a
              repeatable process that ensures consistent results.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default LayoutDesign;